"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _keyringPairs, _registry;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestAccountSigningKey = void 0;
let id = 0;
class TestAccountSigningKey {
    constructor(registry) {
        _keyringPairs.set(this, void 0);
        _registry.set(this, void 0);
        __classPrivateFieldSet(this, _keyringPairs, []);
        __classPrivateFieldSet(this, _registry, registry);
    }
    signPayload(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const findKeyringPair = __classPrivateFieldGet(this, _keyringPairs).find((pair) => pair.address === payload.address);
            if (!findKeyringPair) {
                throw new Error(`Can't find the keyringpair for ${payload.address}`);
            }
            return new Promise((resolve) => {
                const signed = __classPrivateFieldGet(this, _registry).createType('ExtrinsicPayload', payload, { version: payload.version })
                    .sign(findKeyringPair);
                resolve(Object.assign({ id: ++id }, signed));
            });
        });
    }
    addKeyringPair(...keyringPairs) {
        __classPrivateFieldSet(this, _keyringPairs, __classPrivateFieldGet(this, _keyringPairs).concat(...keyringPairs));
    }
}
exports.TestAccountSigningKey = TestAccountSigningKey;
_keyringPairs = new WeakMap(), _registry = new WeakMap();
//# sourceMappingURL=TestAccountSigningKey.js.map